import "./Tutoring.css"

function Tutoring() {
     return (
        <section id="tutoring">
            <div className="sectionBox">
                <div className="tutoring">
                    <nav className="#tutoring">
                        <h1>
                            Tutoring
                        </h1>
                        <p>
                            Offering Tutoring services for VWO students: 
                        </p>
                        <ul>
                            <li>
                                Mathematics A/B/D
                            </li>
                            <li>
                                English
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section>
    );
}

export default Tutoring